var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import bigInt from 'big-integer';
import produce from 'immer';
import { types as apiActions } from '../actions/api';
import { types as processActions } from '../actions/process';
import { types as socketActions } from '../actions/websocket';
import { DefaultSearchContext } from '../utils/constants';
var initialState = {
    processData: {},
    loadingCount: 0,
};
var setData = function (state, payload) {
    return produce(state, function (draftState) {
        var _a, _b;
        var searchID = payload.searchID, modelAlias = payload.modelAlias, data = payload.data;
        var searchIdentifier = modelAlias + "_" + searchID;
        var response = data[0];
        var processDict = state.processData[modelAlias]
            ? draftState.processData[modelAlias].dict
            : {};
        response.processes.forEach(function (processes) {
            processDict[processes.id] = processes;
        });
        var existingSearchList = state.processData[modelAlias]
            ? draftState.processData[modelAlias].searchList
            : {};
        var existingCount = state.processData[modelAlias]
            ? draftState.processData[modelAlias].count
            : {};
        draftState.processData[modelAlias] = {
            count: __assign(__assign({}, existingCount), (_a = {}, _a[searchIdentifier] = response.count, _a)),
            dict: processDict,
            searchList: __assign(__assign({}, existingSearchList), (_b = {}, _b[searchIdentifier] = response.processes.map(function (process) { return process.id; }), _b)),
            references: (state.processData[modelAlias] || {}).references || [],
        };
    });
};
var setClaim = function (state, payload, step) {
    return produce(state, function (draftState) {
        var processName = payload.processName, ids = payload.ids;
        var process = state.processData[processName];
        if (!process) {
            return;
        }
        draftState.processData[processName].references = __spreadArrays(process.references.map(function (ref) {
            if (ids.findIndex(function (id) { return id === ref.id; }) !== -1) {
                return { id: ref.id, count: ref.count + step };
            }
            return ref;
        }), ids
            .filter(function (id) {
            return step == 1 &&
                process.references.findIndex(function (ref) { return ref.id === id; }) === -1;
        })
            .map(function (id) { return ({ id: id, count: 1 }); }));
    });
};
var editOrAddData = function (state, payload) {
    return produce(state, function (draftState) {
        var requests = payload.requests, apiVersion = payload.apiVersion;
        requests.forEach(function (request) {
            var _a;
            var modelAlias;
            if (apiVersion === 2) {
                modelAlias = request.model.alias;
            }
            else {
                modelAlias = request.modelAlias;
            }
            var id = request.id;
            if (state.processData[modelAlias]) {
                if (state.processData[modelAlias].dict[id]) {
                    var processInstance = state.processData[modelAlias].dict[id];
                    if (bigInt(processInstance.update).compare(bigInt(request.update)) < 0) {
                        draftState.processData[modelAlias].dict[id] = request;
                    }
                }
                else {
                    draftState.processData[modelAlias].dict[id] = request;
                }
                var isRefPresent = state.processData[modelAlias].references.some(function (ref) { return ref.id === id; });
                if (!isRefPresent) {
                    draftState.processData[modelAlias].searchList = __assign(__assign({}, state.processData[modelAlias].searchList), (_a = {}, _a[modelAlias + "_" + DefaultSearchContext] = __spreadArrays((state.processData[modelAlias].searchList[modelAlias + "_" + DefaultSearchContext] || []), [
                        id,
                    ]), _a));
                    draftState.processData[modelAlias].references = __spreadArrays(state.processData[modelAlias].references, [
                        { id: id, count: 1 },
                    ]);
                }
            }
        });
        requests.forEach(function (request) {
            var _a;
            var modelAlias;
            if (apiVersion === 2) {
                modelAlias = request.model.alias;
            }
            else {
                modelAlias = request.modelAlias;
            }
            var id = request.id;
            if (!state.processData[modelAlias]) {
                draftState.processData[modelAlias] = {
                    count: 0,
                    dict: (_a = {},
                        _a[id] = request,
                        _a),
                    searchList: {},
                    references: [{ id: id, count: 0 }],
                    fullSearchIds: {},
                };
            }
        });
    });
};
var unSubscribeAndRemove = function (state, payload) {
    return produce(state, function (draftState) {
        var processes = payload.processes;
        var processSet = new Set(processes);
        var processData = {};
        Object.keys(state.processData).forEach(function (pType) {
            var pTypeData = state.processData[pType];
            var pInstToKeep = Object.keys(pTypeData.dict).filter(function (pId) { return !processSet.has(pId); });
            var dict = {};
            pInstToKeep.forEach(function (pId) {
                dict[pId] = state.processData[pType].dict[pId];
            });
            processData[pType] = __assign(__assign({}, state.processData[pType]), { dict: dict, references: pTypeData.references.filter(function (ref) { return !processSet.has(ref.id); }) });
        });
        draftState.processData = processData;
    });
};
var addLoadingResource = function (state, action) {
    return produce(state, function (draftState) {
        console.log('sharingan added by', action.type, action.payload);
        draftState.loadingCount = state.loadingCount + 1;
    });
};
var removeLoadingResource = function (state, action) {
    return produce(state, function (draftState) {
        console.log('sharingan subtract by', action.type, action.payload);
        draftState.loadingCount = Math.max(state.loadingCount - 1, 0);
    });
};
var setSearchProcessIds = function (state, payload) {
    return produce(state, function (draftState) {
        var _a;
        var _b, _c;
        var modelAlias = payload.modelAlias, data = payload.data, searchID = payload.searchID;
        var searchIdentifier = modelAlias + "_" + searchID;
        var ids = data[0].ids;
        draftState.processData[modelAlias] = __assign(__assign({}, state.processData[modelAlias]), { fullSearchIds: __assign(__assign({}, (_c = (_b = state.processData[modelAlias]) === null || _b === void 0 ? void 0 : _b.fullSearchIds, (_c !== null && _c !== void 0 ? _c : {}))), (_a = {}, _a[searchIdentifier] = ids, _a)) });
    });
};
var LOADING_ACTIONS = [
    processActions.SEARCH_PROCESS_DATA,
    processActions.EDIT_PROCESS_DATA,
    processActions.UPDATE_DOCUMENT_PROCESS,
    processActions.GET_UPDATED_PROCESS,
    processActions.GET_UPDATED_PROCESSES,
    processActions.SEARCH_PROCESS_IDS,
];
var UNLOADING_ACTIONS = [
    processActions.SET_PROCESS_DATA,
    processActions.EDIT_PROCESS_SUCCESS_DATA,
    apiActions.API_CANCELLED,
    processActions.SET_SEARCH_PROCESS_IDS,
];
var reducer = function (originalState, action) {
    if (originalState === void 0) { originalState = initialState; }
    var type = action.type, payload = action.payload;
    var state = originalState;
    if (LOADING_ACTIONS.findIndex(function (val) { return val === type; }) !== -1) {
        state = addLoadingResource(originalState, action);
    }
    else if (UNLOADING_ACTIONS.findIndex(function (val) { return val === type; }) !== -1) {
        state = removeLoadingResource(originalState, action);
    }
    switch (type) {
        case processActions.SET_PROCESS_DATA:
            return setData(state, payload);
        case processActions.EDIT_PROCESS_SUCCESS_DATA:
            return editOrAddData(state, payload);
        case processActions.ADD_PROCESS_CLAIM:
            return setClaim(state, payload, 1);
        case processActions.REMOVE_PROCESS_CLAIM:
            return setClaim(state, payload, -1);
        case socketActions.UNSUBSCRIBE_TO_PROCESS:
            return unSubscribeAndRemove(state, payload);
        case processActions.SET_SEARCH_PROCESS_IDS:
            return setSearchProcessIds(state, payload);
    }
    return state;
};
export default reducer;
//# sourceMappingURL=process.js.map